import { Icon, type IconName } from "../../icons";
import { Badge } from "../Badge/Badge";

export interface ModuleCardProps {
  name: string;
  description: string;
  icon: IconName;
  /** Small detail in the footer (e.g. "2 secciones"). */
  stat?: string;
  status?: string;
  onOpen?: () => void;
  index?: number;
}

export function ModuleCard({ name, description, icon, stat, status, onOpen, index = 0 }: ModuleCardProps): React.JSX.Element {
  return (
    <button type="button" className="nb-card nb-module nb-enter" style={{ ["--i" as string]: index }} onClick={onOpen}>
      <div className="nb-module-head">
        <span className="nb-module-icon">
          <Icon name={icon} />
        </span>
        {status ? <Badge label={status} /> : null}
      </div>
      <div>
        <h3 className="nb-module-name">{name}</h3>
        <p className="nb-module-desc">{description}</p>
      </div>
      <div className="nb-module-foot">
        <span className="nb-module-stat">{stat}</span>
        <span className="nb-module-go">
          Open
          <Icon name="arrowRight" />
        </span>
      </div>
    </button>
  );
}
